import icon from "../../assets/customization.svg";
import type { Property } from "../../types";

export const customization: Property = {
  id: "customization",
  title: "customization.title",
  icon,
};
